export const SEED_TEAMS_COUNT = 2;
